import Digitacao from "@pages/Digitacao/Digitacao";

export default Digitacao;
